import React, { useContext, useEffect, useState } from "react";
import { Navigate, Outlet } from "react-router-dom";
import { UserContext } from "../components/UserContext";
import { useTranslate } from "../i18n";

const ProtectedRoute = () => {
  const [isLoading, setIsLoading] = useState(true);
  const [isValid, setIsValid] = useState(false);
  const { bootstrapSession } = useContext(UserContext);
  const { t } = useTranslate();

  useEffect(() => {
    let active = true;

    const verifyToken = async () => {
      try {
        const valid = await bootstrapSession();
        if (active) setIsValid(valid);
      } catch (error) {
        console.error(error);
        if (active) setIsValid(false);
      } finally {
        if (active) setIsLoading(false);
      }
    };

    verifyToken();
    return () => {
      active = false;
    };
  }, [bootstrapSession]);

  if (isLoading) {
    return <div>{t("auth.protectedRoute.loading")}</div>;
  }

  return isValid ? <Outlet /> : <Navigate to="/login" replace />;
};

export default ProtectedRoute;
